import { MultiSelectFieldFilter } from 'module/types/filter-field/filter/multi-select';
import { FC } from 'react';
import { MultiSelectBaseFilterToText } from './multi-select-base-filter';

export const MultiSelectFilterToText: FC<{
  filter: MultiSelectFieldFilter;
}> = ({ filter }) => {
  const {
    field: {
      metaData: { options },
    },
  } = filter;

  return <MultiSelectBaseFilterToText filter={filter} options={options} />;
};
